import React, { FunctionComponent } from 'react';
import styles from './tab-content-item.module.scss';
import { Slide } from 'react-awesome-reveal';
import { ITabContentItemProps } from '../tabs-menu';

export interface ITabContentItemComponentProps extends ITabContentItemProps {
  index: number;
  prevTabIndex: number;
  isAnimated: boolean;
}

export const TabContentItem: FunctionComponent<ITabContentItemComponentProps> = ({
  text,
  image,
  index,
  prevTabIndex,
  isAnimated
}) => {
  const tabContent = (
    <div className={styles.wrapper}>
      <div className={styles.text}>{text}</div>
      <img className={styles.image} src={image.url} alt={image.descritpion} />
    </div>
  );

  return (
    <React.Fragment>
      {isAnimated ? (
        <Slide
          direction={prevTabIndex < index ? 'right' : 'left'}
          duration={Math.abs(index - prevTabIndex) > 1 ? 200 : 300}
          triggerOnce
        >
          {tabContent}
        </Slide>
      ) : (
        tabContent
      )}
    </React.Fragment>
  );
};
